import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const DELETE_EMOTION_CATEGORY_IMG_MUTATION = gql`
    mutation DeleteEmotionCategoryImage($uid: String!) {
      emotion_category_delete_img(uid: $uid) {
        success
        emotion_category {
          uid
          img_file_name
        }
      }
    }
`;

export async function deleteEmotionCategoryImage(uid: string): Promise<{ success: boolean }> {
  const result: FetchResult<{ emotion_category_delete_img: { success: boolean } }> = await graphqlClient.mutate({
      mutation: DELETE_EMOTION_CATEGORY_IMG_MUTATION,
      variables: { uid },
      errorPolicy: 'all',
  });

  if (!result.data || (result.errors && result.errors.length)) {
      throw new MultiError(result.errors || ['Unknown error']);
  }

  return {
    success: result.data.emotion_category_delete_img.success,
  };
}
